import { ProjectSaveParams, ProjectSaveEntryComponent } from './project-save-entry.component';
import { ProjectSaveDialogService } from './project-save-dialog.service';
import { SubscriptionMgr } from './../../../model/SubscriptionMgr';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-project-save-dialog',
  template: ''
})
export class ProjectSaveDialogComponent implements OnDestroy {
  modalRef?: NgbModalRef;
  subscriptionMgr: SubscriptionMgr = new SubscriptionMgr();
  lastTitle: string | null = null;
  constructor(private modalService: NgbModal, private service: ProjectSaveDialogService) {
    this.subscriptionMgr.Subscribe(this.service.requests, (params: ProjectSaveParams) => {
      this.modalRef = this.modalService.open(ProjectSaveEntryComponent, { backdrop: 'static' });
      (this.modalRef.componentInstance as ProjectSaveEntryComponent).Show(params);
    });
  }
  ngOnDestroy() {
    this.subscriptionMgr.CancelSubscriptions();
  }

}
